import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import EditMyExpModal from "./editProfileModals/editExp/EditMyExpModal";


const OptionTray = () => (
    <div className="option-tray">
        <div className="icon primary"><i className="fa fa-eye"></i></div>
        <div className="icon"><i className="fa fa-arrow-up"></i></div>
        <div className="icon"><i className="fa fa-arrow-down"></i></div>
        <div className="icon danger"><i className="fa fa-trash"></i></div>
    </div>
)

function dateDiff(date1,date2) { // Not precise.
    var diff = Math.floor(date2.getTime() - date1.getTime());
    var day = 1000 * 3600 * 24; //ms to one day
    var days = Math.floor(diff/day);
    var months = Math.floor(days/30);
    var years = Math.floor(months/12);
    months = months - years * 12
    days = days - (years * 365) - (months * 30)
    return { years, months, days }
}

const ExpCard = (props) => {
    const [more, setMore] = useState(false);
    var { experience } = props
    // Handle More
    var showMore = false
    if(experience.description.length > 430){
        showMore = true
    }
    var displayDesp = showMore && more ? experience.description : experience.description.slice(0, 430)
    // Handle Date
    var startDate =  experience.startDate
    var endDate = experience.endDate
    if (endDate == undefined) endDate = new Date()
    var { years, months, days } = dateDiff(startDate,endDate)
    var durationString = "(" + (years > 0 ? years + " yrs " : "") + (months > 0 ? months + " mos" : "") + ")"
    if (years < 1 && months < 1) durationString = "(" + days + "days )"
    var startString = startDate.toLocaleString('default', { month: 'short' }) + " " + startDate.getFullYear()
    var endString = experience.active ? "Present" : endDate.toLocaleString('default', { month: 'short' }) + " " + endDate.getFullYear()
    return (
    <div className="card-option">
        <div className="v-align ">
            <div className="wd-pct-20 mg-r-15 b-r-border">
                <div >{startString + " - " + endString + " " + durationString}</div>
                <div>{experience.city + " ," + experience.country}</div>
            </div>
            <div >
                <div className="card-list-header">{experience.title}
                    {experience.active ? <span className="active-badge-static bg-c-primary-active"></span>: null}
                </div>
                <div className="card-list-subheader">{experience.experience}</div>
            </div>
        </div>
        <div className="card-description">
                {displayDesp}
                {showMore && !more ? <span onClick={() => setMore(true)}className="card-description-more f-right">More...</span>: null}
        </div>
        <OptionTray />
    </div>
    )
}

function MyExp(props) {
    const [collapse, setCollapse] = useState(false);
    const toggle = () => setCollapse(!collapse);
    const [ newPlanModal, setNewPlanModal ] = useState(false);
    const toggleNewPlanModal = () => setNewPlanModal(!newPlanModal);

    var { store } = props
    var { profile } = store
    var { empHistory } = profile
    return (
    <div className="mg-t-20" >
        <div className="card" >
        <div className="card-header">
            <div className="card-header-left">
                <h5>Employment History</h5>
            </div>
            <div className="card-header-right">
                <ul className="row" >                        
                    <li><i className="far fa-edit" onClick={toggleNewPlanModal}></i></li>   
                    <li><i className={collapse ? "fa fa-chevron-down" : "fa fa-chevron-up"} onClick={toggle}></i></li>                                 
                    <EditMyExpModal modal={newPlanModal} toggle={toggleNewPlanModal} empHistory={empHistory} />  
                </ul>                    
            </div>
        </div>         
        <Collapse isOpen={!collapse}> 
        
            <div className="card-block">
                <div className="bo-trim" />
                {empHistory.map((experience, i) => (<>
                    <ExpCard experience={experience}/>
                    {i != empHistory.length - 1 ? <div className="bo-card" ></div> : null}
                </>))}
            </div>
        </Collapse>
    </div>
    </div>
        
    );
  }

export default MyExp